<div *ngIf="isKeyExisting" class="k-custom-notification">
  <div class="k-widget k-notification k-notification-warning">
    <div class="k-notification-wrap">
      <span class="k-icon k-i-info"></span>
      <div class="k-notification-content">{{ 'circ_template_data_key_error_notification' | i18n }}</div>
    </div>
  </div>
</div>

<circ-loader [isLoading]="loading">
  <form class="k-form" [formGroup]="form">
    <legend class="k-form-legend">{{ 'circ_template_data_legend' | i18n }}</legend>
    <fieldset class="k-form-fieldset">
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [text]=" 'circ_new_label_value_type' | i18n "></kendo-label>
        <kendo-dropdownlist [data]="dropdownValues" textField="text" valueField="value" [(ngModel)]="selectedItem"
          [ngModelOptions]="{standalone: true}">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <span>{{ dataItem.text | i18n }}</span>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <span>{{ dataItem.text | i18n }}</span>
          </ng-template>
        </kendo-dropdownlist>
        <kendo-formhint>{{ 'circ_template_formhint_value_type' | i18n }}</kendo-formhint>
      </kendo-formfield>

      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [text]=" 'circ_new_label_key' | i18n "></kendo-label>
        <input kendoTextBox [placeholder]="'circ_new_label_placeholder_key' | i18n" formControlName="key" required/>
        <kendo-formhint>{{ 'circ_template_formhint_key' | i18n }}</kendo-formhint>
        <kendo-formerror>{{ 'circ_template_formerror_key' | i18n }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]=" 'circ_template_label_required' | i18n "></kendo-label>
        <input type="checkbox" [(ngModel)]="baseSettings.isRequired" [ngModelOptions]="{standalone: true}" kendoCheckBox />
        <kendo-formhint>{{ 'circ_template_formhint_required' | i18n }}</kendo-formhint>
      </kendo-formfield>

      <div class="k-form-fieldset meta-settings" *ngIf="selectedItem.value == 'number'">
        <kendo-formfield>
          <kendo-label [text]=" 'circ_new_label_min' | i18n "></kendo-label>
          <kendo-numerictextbox
            [title]="'circ_new_label_placeholder_min' | i18n"
            [placeholder]="'circ_new_label_placeholder_min' | i18n"
            [(ngModel)]="numberSettings.min"
            [ngModelOptions]="{standalone: true}">
          </kendo-numerictextbox>
          <kendo-formhint>{{ 'circ_template_formhint_min' | i18n }}</kendo-formhint>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [text]=" 'circ_new_label_max' | i18n "></kendo-label>
          <kendo-numerictextbox [title]="'circ_new_label_placeholder_max' | i18n" [placeholder]="'circ_new_label_placeholder_max' | i18n" [(ngModel)]="numberSettings.max" [ngModelOptions]="{standalone: true}">
          </kendo-numerictextbox>
          <kendo-formhint>{{ 'circ_template_formhint_max' | i18n }}</kendo-formhint>
        </kendo-formfield>
      </div>

      <div class="k-form-fieldset meta-settings" *ngIf="selectedItem.value == 'choice'">
        <kendo-formfield>
          <kendo-label [text]=" 'circ_new_label_choices' | i18n "></kendo-label>
          <kendo-multiselect [(ngModel)]="choiceSettings.choices" allowCustom="true"
            [ngModelOptions]="{standalone: true}"></kendo-multiselect>
          <kendo-formhint>{{ 'circ_template_formhint_choices' | i18n }}</kendo-formhint>
          <kendo-formerror>{{ 'circ_template_formerror_choices' | i18n }}</kendo-formerror>
        </kendo-formfield>
      </div>

      <div class="k-form-buttons">
        <ece-btn-primary (click)="clickSave()" [text]=" 'circ_new_button_save' | i18n"></ece-btn-primary>
        <ece-btn (click)="clickAbort()" [text]=" 'circ_new_button_abort' | i18n "></ece-btn>
      </div>
    </fieldset>
  </form>
</circ-loader>
